<div *ngIf="data.description_preset_description || data.description as desc; else empty" class="d-flex align-items-center">
  <div class="c-field-value c-field-value--view-mode d-flex">
    <span class="c-field-value__icon" (click)="showDescriptionModal()">
      <p500-ui-icon name="eye"></p500-ui-icon>
    </span>
    <span i18n="@@common.show">Show</span>
  </div>
</div>
<ng-template #empty>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
